export default "__VITE_PUBLIC_ASSET__8b23a71d__"